import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';

import { Store, select } from '@ngrx/store';

import * as fromLocale from '../../root-store/locale/locale.selectors';

const DEFAULT_TRANSFORMATION_CONFIG = {
  convertKeyValue: { labelId: 'label' },
  skipKeys: ['source', 'includeKeys', 'skipKeys'],
};

@Injectable({
  providedIn: 'root',
})
export class TextService {
  labels = {};

  constructor(private store: Store) {}

  convert(data, config = {}) {
    return this.store.pipe(select(fromLocale.getLocaleLabels)).pipe(
      map((labels) => {
        this.labels = labels;
        return this.applyLabel(
          data,
          Object.assign({}, DEFAULT_TRANSFORMATION_CONFIG, config)
        );
      })
    );
  }

  private applyLabel(data, transformationConfig) {
    if (!data) return data;

    if (Array.isArray(data)) {
      return data.map((item) => this.applyLabel(item, transformationConfig));
    } else if (typeof data === 'object') {
      for (let key in transformationConfig.convertKeyValue) {
        if (Array.isArray(data[key])) {
          data[transformationConfig.convertKeyValue[key]] = this.labels
            ? data[key].map((lId) => {
                return this.labels['data'][lId]?.value;
              })
            : data[key];
        } else if (data[key]) {
          data[transformationConfig.convertKeyValue[key]] = this.labels
            ? this.labels['data'][data[key]]?.value
            : data[key];
        }
      }
    }

    const { skipKeys: skipKeysData, includeKeys = [] } = data;
    const { skipKeys: skipKeysConfig } = transformationConfig;
    const skipAllKeys = skipKeysData || skipKeysConfig;
    const skipKeys = includeKeys
      ? skipAllKeys.filter((key) => !includeKeys.includes(key))
      : skipAllKeys;

    // Iterate through nested property if text needs to be changed
    for (let key of Object.getOwnPropertyNames(data)) {
      if (
        !skipKeys.includes(key) &&
        data[key] &&
        typeof data[key] === 'object'
      ) {
        data[key] = this.applyLabel(data[key], transformationConfig);
      }
    }

    return data;
  }
}
